module.exports = __webpack_public_path__ + "img/slowDown.56bb0fab.png";